import { useState, useCallback, useEffect, useRef } from 'react'
import { getEnvironment } from 'src/config/env'
import { selectMarketState, selectPostalCode } from '../reducers/market'
import { useSelector } from 'react-redux'
import { PlanData } from 'src/constants/standaloneData'
const env = getEnvironment()

export const useIsRSNAvailable = (rsn) => {
  const postalCode = useSelector(selectPostalCode)
  const { regionCode } = useSelector(selectMarketState)
  const [isAvailable, setIsAvailable] = useState(false)
  const [rsnData, setRsnData] = useState(null)
  const hasChecked = useRef(false)

  const isValid = PlanData?.[rsn] || rsn === 'rsn_data'
  const checkAvailability = useCallback(async () => {
    if (!postalCode || !regionCode || !isValid) return

    try {
      const response = await fetch(`${env.default.host}/data/${rsn}/${regionCode}.json`)
      if (!response.ok) {
        // If file doesn't exist, treat as not available, don't throw
        setIsAvailable(false)
        setRsnData(null)
        return
      }
      const postalCodes = await response.json()
      if (Array.isArray(postalCodes)) {
        setIsAvailable(postalCodes.includes(postalCode))
        setRsnData(PlanData[rsn])
      } else {
        setRsnData(postalCodes[postalCode])
      }
    } catch (error) {
      console.error(`Error checking ${rsn} availability:`, error)
      setIsAvailable(false)
      setRsnData(null)
    }
  }, [postalCode, regionCode, rsn])

  useEffect(() => {
    if (!hasChecked.current && postalCode && regionCode && !isAvailable && isValid) {
      checkAvailability()
      hasChecked.current = true
    }
  }, [postalCode, regionCode, rsn, isAvailable, checkAvailability])

  return { isAvailable, rsnData }
}
